import React from "react";
import "../index.css";

export const SignIn = () => {
  return (
    <>
      <div className="main-container">
        <h1 className="main-title valign-text-middle roboto-medium-black-48px">
          Sign In
        </h1>
        <div className="signup-container">
          <div className="form-container">
            <form action="/login" method="POST" className="sign-up-form">
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Email
                </h2>
                <input
                  className="input"
                  type="email"
                  name="email"
                  id="email"
                  required="true"
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Password
                </h2>
                <input
                  className="input"
                  type="password"
                  name="password"
                  id="password"
                />
              </div>
              <div className="first-name-enter">
                <input
                  className="btn button-primary white s18px"
                  id="submit-btn"
                  type="submit"
                  value="Log In"
                />
              </div>
            </form>
          </div>

          {/* <div className="api-container">
            <div className="group-27">
              <div className="overlap-group">
                <div className="button-secondary border-className-1">
                  <div className="text valign-text-middle roboto-normal-black-18px">
                    Continue with Google
                  </div>
                </div>
                <div className="group-25">
                  <div className="overlap-group1">
                    <img
                      className="vector-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-3@2x.svg"
                    />
                    <img
                      className="vector"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-11@2x.svg"
                    />
                    <img
                      className="vector-4"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-12@2x.svg"
                    />
                    <img
                      className="vector-3"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-6@2x.svg"
                    />
                  </div>
                </div>
              </div>
              <div className="button-secondary-2 border-className-1">
                <div className="overlap-group2">
                  <div className="text-2 valign-text-middle roboto-normal-black-18px">
                    Continue with Apple ID
                  </div>
                  <div className="file-iconsapple">
                    <img
                      className="vector-1"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-14@2x.svg"
                    />
                  </div>
                </div>
              </div>
              <div className="button-secondary-1 border-className-1">
                <div className="overlap-group3">
                  <div className="text-1 valign-text-middle roboto-normal-black-18px">
                    Continue with Facebook
                  </div>
                  <div className="brandicofacebook-rect"></div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};
